__turbopack_context__.v({
  "container": "VisualGeneralInfo-module-scss-module__vhOrCW__container",
  "crossline": "VisualGeneralInfo-module-scss-module__vhOrCW__crossline",
  "description": "VisualGeneralInfo-module-scss-module__vhOrCW__description",
  "link": "VisualGeneralInfo-module-scss-module__vhOrCW__link",
  "root": "VisualGeneralInfo-module-scss-module__vhOrCW__root",
  "title": "VisualGeneralInfo-module-scss-module__vhOrCW__title",
});
